export default __webpack_public_path__ + "6dd02fc10801eec814bda5e58e0907fc.svg";